import SubscriptionsContainer from './SubscriptionsContainer'

export default SubscriptionsContainer
